import { render } from "./landingPage.vue?vue&type=template&id=6ed965dc&scoped=true"
import script from "./landingPage.js?vue&type=script&lang=js"
export * from "./landingPage.js?vue&type=script&lang=js"

import "./landingPage.vue?vue&type=style&index=0&id=6ed965dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed965dc"]])

export default __exports__